import { observer } from 'mobx-react';
import { useState, useEffect } from 'react';
import ChatStore from '../../stores/ChatStore';
import { durationIcon } from '../../assets';
import './index.css';

const Duration = () => {
  const callState = ChatStore.callState;
  const createdAt = callState?.createdAt;

  const [duration, setDuration] = useState('00:00');

  useEffect(() => {
    const updateDuration = () => {
      if (!createdAt) return;

      // Calculate time elapsed since createdAt
      const now = new Date();
      const createdTime = new Date(createdAt);
      const elapsedMs = now.getTime() - createdTime.getTime();

      // Convert to seconds and add any additional seconds if needed
      const totalSeconds = Math.floor(elapsedMs / 1000);

      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      setDuration(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
    };

    const interval = setInterval(updateDuration, 1000);

    return () => clearInterval(interval);
  }, [createdAt]);

  return (
    <div className="tech-call-container-duration">
      <img src={durationIcon} alt="duration" />
      <span>{duration}</span>
    </div>
  );
};

export default observer(Duration);